import { HHTextField } from '@hinge-health/react-component-library';
import { InputAdornment } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import {
  getFormErrorsForInnerField,
  innerFieldHasErrors,
} from '../../../../utils/contract-utils';
import { RawInnerPackageFormValues } from '../custom-package-types';
import { fieldArrayName } from '../form';

export interface FeePercentInputProps {
  wholeFormDisabled: boolean | undefined;
  index: number;
}

export const FeePercentInput = ({
  wholeFormDisabled,
  index,
}: FeePercentInputProps): JSX.Element => {
  const {
    control,
    formState: { errors },
  } = useFormContext<{ selectedPackages: RawInnerPackageFormValues[] }>();

  return (
    <Controller
      control={control}
      name={`${fieldArrayName}.${index}.feePercent`}
      render={({ field: { onChange, value } }): JSX.Element => (
        <HHTextField
          data-testid="contract-fee-percent-input"
          hhVariant="variant-bypass"
          label="Fee Percent"
          disabled={wholeFormDisabled}
          fullWidth
          inputProps={{
            inputMode: 'decimal',
            pattern: '[0-9]*',
            step: '0.01',
            min: '0',
            max: '100',
            name: `${fieldArrayName}.${index}.feePercent`,
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment
                position="end"
                disableTypography
                sx={{ color: 'gray' }}
              >
                %
              </InputAdornment>
            ),
          }}
          error={innerFieldHasErrors('feePercent', index, errors)}
          helperText={getFormErrorsForInnerField('feePercent', index, errors)}
          value={value}
          onChange={onChange}
          type="number"
          InputLabelProps={{ sx: { color: 'gray' } }}
        />
      )}
    />
  );
};
